module.exports = __webpack_public_path__ + "img/agenda.ccdcf05c.svg";